import React from 'react';
import P from 'prop-types';
import cx from 'classnames';

import { ThemeContext } from 'components/App/';
import ArrowDown from './Icons/ArrowDown';
import CircleTick from './Icons/CircleTick';
import Cog from './Icons/Cog';
import Group from './Icons/Group';
import LaunchExternal from './Icons/LaunchExternal';
import Pencil from './Icons/Pencil';
import SignOut from './Icons/SignOut';
import './Icon.scss';

const Icon = ({ color, className, name, size }) => {
  if (!Icon.NAME[name]) {
    console.error('Icon not found');
    return null;
  }

  const IconComponent = Icon.NAME[name];

  return (
    <ThemeContext.Consumer>
      {
        (context) => {
          const fill = (color === 'primary' || color === 'secondary') ? context[color] : color;
          return (
            <IconComponent
              className={cx('Icon', className)}
              fill={fill}
              size={Icon.SIZE[size] || size}
            />
          );
        }
      }
    </ThemeContext.Consumer>
  );
};

Icon.NAME = {
  arrowDown: ArrowDown,
  circleTick: CircleTick,
  cog: Cog,
  group: Group,
  launchExternal: LaunchExternal,
  pencil: Pencil,
  signout: SignOut,
};

Icon.SIZE = {
  xxs: 14,
  xs: 16,
  sm: 18,
  md: 20,
  lg: 22,
  xl: 24,
  xxl: 26,
}

Icon.propTypes = {
  color: P.string,
  className: P.string,
  size: P.oneOfType([
    P.number,
    P.oneOf(Object.keys(Icon.SIZE)),
  ]),
  name: P.oneOf(Object.keys(Icon.NAME)).isRequired,
};

Icon.defaultProps = {
  color: '#333',
  size: Icon.SIZE.md,
};

export default Icon;
